/* stylelint-disable max-nesting-depth */

/**
    @prop --uic-tooltip-border-color: border color of the tooltip panel
    @prop --uic-tooltip-border-color-error: border color of the tooltip panel for error variant
    @prop --uic-tooltip-background-color: background color of the tooltip panel
    @prop --uic-tooltip-z-index: z-index of the tooltip panel
*/

uic-tooltip {
    display: contents;
    position: relative;
    user-select: none;
}

uic-tooltip[open] {
    .uic-tooltip__positioner {
        pointer-events: auto;
    }

    .uic-tooltip__content {
        opacity: 1;
    }
}

uic-tooltip[disabled] {
    .uic-tooltip__over {
        cursor: default;
    }
}

uic-tooltip[error] {
    .uic-tooltip__content {
        box-shadow: 0 0 4px 0 var(--uic-atom-shadow-color-error);
        border-color: var(--uic-tooltip-border-color-error);
    }

    .uic-tooltip__positioner[data-popper-placement="top-end"]
        .uic-tooltip__content,
    .uic-tooltip__positioner[data-popper-placement="bottom-end"]
        .uic-tooltip__content {
        &::after {
            border-color: transparent var(--uic-tooltip-border-color-error)
                transparent transparent;
        }
    }

    .uic-tooltip__positioner[data-popper-placement="top-start"]
        .uic-tooltip__content,
    .uic-tooltip__positioner[data-popper-placement="bottom-start"]
        .uic-tooltip__content {
        &::after {
            border-color: transparent transparent transparent
                var(--uic-tooltip-border-color-error);
        }
    }
}

.uic-tooltip {
    &__over {
        cursor: help;
        display: inline-block;
        touch-action: none;

        uic-icon:first-child:last-child {
            display: block;
        }
    }

    &__positioner {
        position: absolute;
        pointer-events: none;
        z-index: var(--uic-tooltip-z-index, 1000);
    }

    &__content {
        position: relative;
        text-align: left;
        opacity: 0;
        padding: 8px 12px;
        border: 1px solid var(--uic-tooltip-border-color);
        background-color: var(--uic-tooltip-background-color);
        box-shadow: 0 0 6px 0 var(--uic-color-blue6);
        font-size: 0.8rem;
        line-height: 16px;
        white-space: normal;

        &::after {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
        }

        &::before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
        }

        @media #{$breakpoint_tablet} {
            min-width: 112px;
        }

        @media #{$breakpoint_desktop} {
            min-width: 134px;
        }
    }

    &__content--restricted-width {
        @media #{$breakpoint_tablet} {
            max-width: 192px;
        }

        @media #{$breakpoint_desktop} {
            max-width: 230px;
        }
    }

    &__close-button {
        position: absolute;
        top: 8px;
        right: 8px;
    }

    &__content--closeable {
        padding: calc(var(--uic-icon-button-height) / 2)
            calc(var(--uic-icon-button-width) + 16px)
            calc(var(--uic-icon-button-height) / 2) 16px;
    }
}

.uic-tooltip__positioner[data-popper-placement="top-start"]
    .uic-tooltip__content {
    &::after {
        bottom: -13px;
        left: -1px;
        border-bottom: 13px solid transparent;
        border-left: 13px solid var(--uic-tooltip-border-color);
    }

    &::before {
        bottom: -11px;
        left: 0;
        z-index: 10;
        border-bottom: 11px solid transparent;
        border-left: 11px solid var(--uic-tooltip-background-color);
    }
}

.uic-tooltip__positioner[data-popper-placement="top-end"]
    .uic-tooltip__content {
    &::after {
        right: -1px;
        bottom: -13px;
        border-right: 13px solid var(--uic-tooltip-border-color);
        border-bottom: 13px solid transparent;
    }

    &::before {
        right: 0;
        bottom: -11px;
        z-index: 10;
        border-right: 11px solid var(--uic-tooltip-background-color);
        border-bottom: 11px solid transparent;
    }
}

.uic-tooltip__positioner[data-popper-placement="bottom-start"]
    .uic-tooltip__content {
    &::after {
        top: -13px;
        left: -1px;
        border-top: 13px solid transparent;
        border-left: 13px solid var(--uic-tooltip-border-color);
    }

    &::before {
        top: -11px;
        left: 0;
        z-index: 10;
        border-top: 11px solid transparent;
        border-left: 11px solid var(--uic-tooltip-background-color);
    }
}

.uic-tooltip__positioner[data-popper-placement="bottom-end"]
    .uic-tooltip__content {
    &::after {
        top: -13px;
        right: -1px;
        border-top: 13px solid transparent;
        border-right: 13px solid var(--uic-tooltip-border-color);
    }

    &::before {
        top: -11px;
        right: 0;
        z-index: 10;
        border-top: 11px solid transparent;
        border-right: 11px solid var(--uic-tooltip-background-color);
    }
}
